import {
    AfterViewInit,
    Component,
    ElementRef,
    Input,
    OnChanges,
    OnDestroy,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import gsap, { Power1, Power4 } from 'gsap';
import { AbstractComponentMobile } from '../../abstract/abstract-component-global.directive';

@Component({
    selector: 'web-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    imports: [],
})
export class LoaderComponent extends AbstractComponentMobile implements AfterViewInit, OnChanges, OnDestroy {
    public tag = '[LoadingComponent]';

    @Input()
    public show = false;

    @Input()
    public absolute = false;

    @Input()
    public message?: string;

    /**
     * If true, loader takes 100% height (ignoring safe area bottom).
     * Use for full-page blocking operations during critical updates.
     * Default: false
     */
    @Input()
    public fullHeight = false;

    @ViewChild('loader')
    private loaderElRef!: ElementRef;

    private loader?: HTMLDivElement;

    private tl?: gsap.core.Timeline;

    ngAfterViewInit(): void {
        this.loader = this.loaderElRef.nativeElement as HTMLDivElement;

        this.tl = gsap.timeline({ repeat: -1, repeatDelay: 0.5 });
        this.tl.to('.spinner', { rotation: 360, duration: 2.4, ease: Power1.easeInOut, stagger: 0.03 });
        this.tl.to('.spinner', { scale: 1.5, duration: 1, ease: Power1.easeIn }, '<');
        this.tl.to('.spinner', { scale: 1, delay: 0.2, duration: 1, ease: Power4.easeIn }, '>');

        if (!this.show) {
            this.tl.pause();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes['show'] && changes['show'].currentValue !== changes['show'].previousValue) {
            if (changes['show'].currentValue === true) {
                this.loader?.classList.remove('hidden');
                if (this.tl && !this.tl.isActive()) {
                    this.tl.play(0);
                }
            } else {
                this.loader?.removeEventListener('transitionend', this.fadeOutEnd);
                this.loader?.addEventListener('transitionend', this.fadeOutEnd);
            }
        }
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();

        this.loader?.removeEventListener('transitionend', this.fadeOutEnd);
    }

    public fadeOutEnd = () => {
        if (!this.show) {
            if (this.tl) {
                this.tl.pause(0);
            }
            this.loader?.classList.add('hidden');
            this.loader?.removeEventListener('transitionend', this.fadeOutEnd);
        }
    };
}
